import { render, staticRenderFns } from "./AttoreList.vue?vue&type=template&id=ce592cfa&"
import script from "./AttoreList.vue?vue&type=script&lang=ts&"
export * from "./AttoreList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports